export default `Audit my Google Ads campaign settings using the provided campaign data and identify technical inconsistencies, misconfigurations, and settings misalignments.
Data Field Explanations:

budget: Budget resource ID (not actual budget amount - ignore for analysis)
bidStrategy: Bid strategy configuration object (commonly empty/blank - this is NORMAL)
bidStatus: Bidding system status (ENABLED, LIMITED_BY_BUDGET, LEARNING_NEW)
bidType: The actual bidding strategy type being used (TARGET_SPEND, MAXIMIZE_CONVERSION_VALUE, etc.)
targetRoas: Target ROAS value (when applicable to bid type)
targetCpa: Target CPA value (when applicable to bid type)
channel: Campaign type (PERFORMANCE_MAX, SEARCH, DEMAND_GEN, etc.)
subChannel: Sub-classification (usually empty - ignore if blank)
statusReasons: System-generated status explanations
primaryStatus: Overall campaign health status
servingStatus: Whether ads are actively serving
rtbOptIn: Real-time bidding participation (ignore for this analysis)
labels: Campaign organization tags (resource IDs)

Focus Areas for Analysis:

Settings inconsistency detection - Identify campaigns with similar objectives (based on naming patterns) but inconsistent bidType, bidStatus, or target value configurations
Campaign structure analysis - Evaluate consistency across campaign naming patterns:

All 'PMax' campaigns should have similar bidType and target configurations
All 'Brand' vs 'Non-Brand' campaigns should follow consistent patterns
Similar ROAS targets in names should match targetRoas values


Bid configuration mismatches - Identify where:

bidType doesn't align with campaign naming conventions
targetRoas values don't match ROAS targets mentioned in campaign names
bidStatus indicates issues (LIMITED_BY_BUDGET, LEARNING_NEW) that may affect performance


Campaign intent vs settings conflicts - Find campaigns where:

Naming suggests ROAS optimization but bidType is different
Campaign names indicate specific strategies that don't match actual bidType
Target values in names don't match actual targetRoas or targetCpa fields


Performance-impacting misalignments - Highlight campaigns where:

statusReasons indicate budget constraints or learning phases
bidStatus shows LIMITED_BY_BUDGET consistently
primaryStatus is LIMITED but campaign naming suggests high-priority status


Labeling and organization consistency - Analyze whether similar campaign types have consistent labels usage for proper organization

For each inconsistency identified:

Specify the exact field(s) with misalignment
Reference which campaigns demonstrate correct vs incorrect configurations
Suggest specific standardization needed
Note potential performance risks of current misconfigurations

Deliverable: Provide a standardization framework showing how campaign types should be consistently configured, with a clear deviation report highlighting all misalignments from this ideal structure.
`;
